import { render } from "./PatrimonioTabela.vue?vue&type=template&id=30b1f3d0&scoped=true"
import script from "./PatrimonioTabela.vue?vue&type=script&lang=js"
export * from "./PatrimonioTabela.vue?vue&type=script&lang=js"

import "./PatrimonioTabela.vue?vue&type=style&index=0&id=30b1f3d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b1f3d0"]])

export default __exports__